import { DEFAULT_FONT } from "./fonts";

// Fallbacks for tenant-configured Link Hub colors when a profile leaves them unset.
export const THEME_DEFAULTS = {
  background: "#F5F2E9",
  heading: "#000000",
  body: "#6B7280",
  accent: "#4F9A85",
  button: "#FFFFFF",
  darkText: "#1a1a1a",
  lightText: "#ffffff",
};

const BUTTON_RADII = { square: "0", rounded: "0.75rem", pill: "9999px" };

export const getButtonRadius = (style) => BUTTON_RADII[style] || BUTTON_RADII.rounded;

// Readable text color for a tenant-chosen #RRGGBB background.
export const getContrastText = (hexColor) => {
  const hex = hexColor.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? THEME_DEFAULTS.darkText : THEME_DEFAULTS.lightText;
};

/** Resolves a Link Hub profile into the tenant colors, fonts and radius used by the page and its forms. */
export const getLinkHubTheme = (profile) => {
  const accent = profile?.buttonColor || THEME_DEFAULTS.accent;
  const bodyFont = profile?.bodyFont || DEFAULT_FONT;
  const radius = getButtonRadius(profile?.buttonStyle);
  return {
    accent,
    accentTint: `${accent}15`,
    heading: profile?.displayNameColor || THEME_DEFAULTS.heading,
    body: profile?.taglineColor || THEME_DEFAULTS.body,
    background: profile?.backgroundColor || THEME_DEFAULTS.background,
    headingFont: profile?.headingFont || DEFAULT_FONT,
    bodyFont,
    radius,
    primaryButtonStyle: {
      backgroundColor: accent,
      color: getContrastText(accent),
      borderRadius: radius,
      fontFamily: bodyFont,
    },
  };
};
